export const isMouseInElement = (
  element: HTMLElement | SVGElement,
  event: MouseEvent
): boolean => {
  const { clientX, clientY } = event
  const { left, top, width, height } = element.getBoundingClientRect()

  return !(
    clientX < left ||
    clientX > left + width ||
    clientY < top ||
    clientY > top + height
  )
}
